import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { HorizontalProductListWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductRecommendationsDSWidget } from './product-reco-ds-widget'
import { ProductRecommendationsLegacyWidget } from './product-reco-legacy-widget'

const ProductRecommendations = (props: PLTypedWidgetProps<HorizontalProductListWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <ProductRecommendationsDSWidget {...props} />
  }
  return <ProductRecommendationsLegacyWidget {...props} />
}

export const ProductRecommendationsWidget: PLTypedWidgetInterface<
  HorizontalProductListWidgetData,
  WidgetType.HORIZONTAL_PRODUCT_LIST
> = {
  id: WidgetType.HORIZONTAL_PRODUCT_LIST,
  errorBoundary: PLBaseErrorBoundary,
  render: ProductRecommendations,
}
